import styled from "styled-components";
import { IconProps } from "./types";
import SIZING from "../../designSystem/sizing";

export const Icon = styled.img<IconProps>`
  max-height: ${({ height }) => (height ? height : SIZING.ICON.HEIGHT.STANDARD)};
  /* UI glyphs are monochrome, not media: let the page-wide dark-mode invert flip them too, otherwise a dark stroke sits on a dark background. */
  @media (prefers-color-scheme: dark) {
    filter: none;
  }
  ${({ $backgroundColor }) =>
    $backgroundColor
      ? `
        background-color: ${$backgroundColor};
        border-radius: ${SIZING.RADIUS.SMALL};
        padding: 3px;
    `
      : ""}
`;
